module.exports = __webpack_public_path__ + "img/home.481d7048.png";